import React, { useEffect } from "react";
import queryString from 'query-string';

// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";

// Views
import AgendamentoVistoria from "../../views/Shared/Transportador/AgendamentoVistoria";

//Context
import { useAuth } from "../../context/auth";

export default function AgendamentoVistoriaPortal({ history }) {
    const { setLoading } = useAuth();

    const [rowEdit, set_rowEdit] = React.useState(null);
    const loadItem = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);
        if (params != null && params.protocolo != null && params.requerimento != null) {
            setLoading(true);
            api_GET(`AgendamentoVistoria/GetItemListByProtocoloAndRequerimento/${params.protocolo}/${params.requerimento}`)
                .then(result => set_rowEdit(result.data))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
        else {
            showMessage("Aviso", "URL inválida!", 'error', null);
        }
    }

    useEffect(() => {
        loadItem();
    }, []);

    return (
        <>
            {rowEdit &&
                <AgendamentoVistoria requerimentoAgendamento={rowEdit}></AgendamentoVistoria>
            }
        </>
    );
}